<template>
  <div>
    <div class="medal-type">
      <img src="@/assets/img/アセット 72@3x.png" />
      <div v-show="activeHomeTown">
        <div class="gold-medal-count position-Adjustment">{{ goldMedalCount }} 個</div>
        <div class="silver-medal-count position-Adjustment">{{ silverMedalCount }} 個</div>
        <div class="copper-medal-count position-Adjustment">{{ copperMedalCount }} 個</div>
      </div>
      <div v-show="activeTeapicking">
        <div class="gold-medal-count position-Adjustment">{{ goldMedalCountTea }} 個</div>
        <div class="silver-medal-count position-Adjustment">{{ silverMedalCountTea }} 個</div>
        <div class="copper-medal-count position-Adjustment">{{ copperMedalCountTea }} 個</div>
      </div>
    </div>
    <div class="medal-histry">
      <div id="medal-type-itemsHome" v-show="activeHomeTown">
        <ul class="medal-items">
          <li class="medal-item-type" v-for="item in medalList" :key="item.id">
            <img v-bind:src="item.image" />
            <p v-bind:style="item.color_style">
              <span class="month">{{ item.created_at | moment("MM") }}</span>
              <span class="day">{{ item.created_at | moment("DD") }}</span>
            </p>
          </li>
        </ul>
      </div>
      <div id="medal-type-itemsTea" v-show="activeTeapicking">
        <ul class="medal-items">
          <li class="medal-item-type" v-for="item in medalListTea" :key="item.id">
            <img v-bind:src="item.image" />
            <p v-bind:style="item.color_style">
              <span class="month">{{ item.created_at | moment("MM") }}</span>
              <span class="day">{{ item.created_at | moment("DD") }}</span>
            </p>
          </li>
        </ul>
      </div>
      <img v-show="activeHomeTown" src="@/assets/img/アセット 73@3x.png" />
      <img v-show="activeTeapicking" src="@/assets/img/アセット 79@3x.png" />
      <p class="show-active-home" @click="showHomeTown"></p>
      <p class="show-active-tea" @click="showTeapicking"></p>
    </div>
    <img v-show="isActiveUp" class="up-arrow" src="@/assets/img/アセット 77@3x.png" @click="pushUp" />
    <img
      v-show="isActiveDown"
      class="down-arrow"
      src="@/assets/img/アセット 78@3x.png"
      @click="pushDown"
    />
  </div>
</template>

<script>
import moment from "moment";

export default {
  name: "History",
  beforeCreate: function () {
    document.body.className = "history";
  },
  data() {
    return {
      activeTeapicking: false,
      activeHomeTown: true,
      isActiveUp: false,
      isActiveDown: false,
      itemList: [],
      medalList: [],
      medalListTea: [],
      goldMedalCount: 0,
      silverMedalCount: 0,
      copperMedalCount: 0,
      goldMedalCountTea: 0,
      silverMedalCountTea: 0,
      copperMedalCountTea: 0,
    };
  },
  async mounted() {
    const res = await this.axios
      .get(process.env.API_ENDPOINT + "/plays/part", {
        headers: {
          Authorization:
            "Bearer " + this.$cookies.get('token'),
          "Ocp-Apim-Subscription-Key": process.env.SUBSCRIPTION_KEY,
        },
      })
      .then((response) => (this.itemList = response.data))
      .catch((response) => console.log(response));
    const itemCount = Object.keys(this.itemList);
    const len = itemCount.length;

    //itemListのデータを逆順でループする
    for (let i = len - 1; i >= 0; i--) {
      //故郷
      if (this.itemList[i].song_id === 1) {
        //金メダル
        if (this.itemList[i].number_to_completion === 1) {
          this.medalList.push({
            image: require("@/assets/img/アセット 76@3x.png"),
            created_at: this.itemList[i].created_at,
            color_style: "color: #674400",
          });
          this.goldMedalCount += 1;
          //銀メダル
        } else if (this.itemList[i].number_to_completion === 2) {
          this.medalList.push({
            image: require("@/assets/img/アセット 75@3x.png"),
            created_at: this.itemList[i].created_at,
            color_style: "color: #3E3E3E",
          });
          this.silverMedalCount += 1;
          //銅メダル
        } else {
          this.medalList.push({
            image: require("@/assets/img/アセット 74@3x.png"),
            created_at: this.itemList[i].created_at,
            color_style: "color: #A34000",
          });
          this.copperMedalCount += 1;
        }
        //茶摘み
      } else {
        // 金メダル
        if (this.itemList[i].number_to_completion === 1) {
          this.medalListTea.push({
            image: require("@/assets/img/アセット 76@3x.png"),
            created_at: this.itemList[i].created_at,
            color_style: "color: #674400",
          });
          this.goldMedalCountTea += 1;
          // 銀メダル
        } else if (this.itemList[i].number_to_completion === 2) {
          this.medalListTea.push({
            image: require("@/assets/img/アセット 75@3x.png"),
            created_at: this.itemList[i].created_at,
            color_style: "color: #3E3E3E",
          });
          this.silverMedalCountTea += 1;
          // 銅メダル
        } else {
          this.medalListTea.push({
            image: require("@/assets/img/アセット 74@3x.png"),
            created_at: this.itemList[i].created_at,
            color_style: "color: #A34000",
          });
          this.copperMedalCountTea += 1;
        }
      }
    }
    if (this.medalList.length > 15) {
      this.isActiveDown = true;
    }
    this.$store.commit("FIRST_PITTAN", false);
  },
  filters: {
    moment: function (date, format) {
      return moment(date).format(format);
    },
  },
  methods: {
    //故郷の履歴を表示する
    showHomeTown() {
      document.getElementById("medal-type-itemsTea").scrollTop = 0;
      this.activeTeapicking = false;
      this.activeHomeTown = true;
      if (this.medalList.length > 15) {
        this.isActiveDown = true;
      } else {
        this.isActiveDown = false;
        this.isActiveUp = false;
      }
    },
    // 茶摘みの履歴を表示する
    showTeapicking() {
      document.getElementById("medal-type-itemsHome").scrollTop = 0;
      this.activeHomeTown = false;
      this.activeTeapicking = true;
      if (this.medalListTea.length > 15) {
        this.isActiveDown = true;
      } else {
        this.isActiveDown = false;
        this.isActiveUp = false;
      }
    },
    // 下矢印ボタン押下時の処理
    pushDown() {
      if (this.activeHomeTown === true) {
        const scrollPosition = document.getElementById("medal-type-itemsHome")
          .scrollTop;
        const scrollHeight = document.getElementById("medal-type-itemsHome")
          .scrollHeight;
        const scrollBoundary = scrollHeight - scrollPosition - 475;
        if (scrollBoundary > 136) {
          document.getElementById("medal-type-itemsHome").scrollTop =
            136 + scrollPosition;
          const afterScrollPosition = document.getElementById(
            "medal-type-itemsHome"
          ).scrollTop;
          const afterScrollHeight = document.getElementById(
            "medal-type-itemsHome"
          ).scrollHeight;
          const afterScrollBoundary =
            afterScrollHeight - afterScrollPosition - 475;
          this.isActiveUp = true;
          if (afterScrollBoundary < 136) {
            this.isActiveUp = true;
            this.isActiveDown = false;
          }
        }
      } else {
        const scrollPosition = document.getElementById("medal-type-itemsTea")
          .scrollTop;
        const scrollHeight = document.getElementById("medal-type-itemsTea")
          .scrollHeight;
        const scrollBoundary = scrollHeight - scrollPosition - 475;
        if (scrollBoundary > 136) {
          document.getElementById("medal-type-itemsTea").scrollTop =
            136 + scrollPosition;
          const afterScrollPosition = document.getElementById(
            "medal-type-itemsTea"
          ).scrollTop;
          const afterScrollHeight = document.getElementById(
            "medal-type-itemsTea"
          ).scrollHeight;
          const afterScrollBoundary =
            afterScrollHeight - afterScrollPosition - 475;
          this.isActiveUp = true;
          if (afterScrollBoundary < 136) {
            this.isActiveUp = true;
            this.isActiveDown = false;
          }
        }
      }
    },
    // 上矢印ボタン押下時の処理
    pushUp() {
      if (this.activeHomeTown === true) {
        const scrollPosition = document.getElementById("medal-type-itemsHome")
          .scrollTop;
        if (scrollPosition >= 136) {
          document.getElementById("medal-type-itemsHome").scrollTop =
            scrollPosition - 136;
          const afterScrollPosition = document.getElementById(
            "medal-type-itemsHome"
          ).scrollTop;
          this.isActiveDown = true;
          if (afterScrollPosition === 0) {
            this.isActiveUp = false;
            this.isActiveDown = true;
          }
        }
      } else {
        const scrollPosition = document.getElementById("medal-type-itemsTea")
          .scrollTop;
        if (scrollPosition >= 136) {
          document.getElementById("medal-type-itemsTea").scrollTop =
            scrollPosition - 136;
          const afterScrollPosition = document.getElementById(
            "medal-type-itemsTea"
          ).scrollTop;
          if (afterScrollPosition === 0) {
            this.isActiveUp = false;
            this.isActiveDown = true;
          }
        }
      }
    },
  },
};
</script>

<style>
body.history {
  background-image: url("~@/assets/img/th_アセット 1@0.5x.jpg");
  background-size: cover;
  background-repeat: no-repeat;
}
.position-left {
  position: absolute;
  top: -40px;
  left: 10px;
}
.title p {
  font-size: 50px;
  font-weight: bold;
  color: white;
}
.target-result {
  position: relative;
  top: 50px;
  left: -300px;
}
.medal-type {
  float: left;
  clear: both;
  position: relative;
  z-index: 10;
  left: 20px;
}
.medal-type img {
  width: 245px;
}
.medal-histry {
  float: right;
  position: relative;
  z-index: 10;
  right: 10px;
}
.medal-histry img {
  width: 750px;
}
#medal-type-itemsHome {
  position: absolute;
  z-index: 50;
  top: 110px;
  left: 50px;
  width: 650px;
  height: 480px;
  overflow: hidden;
}
#medal-type-itemsTea {
  position: absolute;
  z-index: 50;
  top: 110px;
  left: 50px;
  width: 650px;
  height: 480px;
  overflow: hidden;
}
.medal-items {
  display: flex;
  flex-wrap: wrap;
  margin-left: -40px;
}
.medal-item-type {
  list-style: none;
  position: relative;
}
.medal-item-type img {
  width: 100px;
  margin: 10px 10px 90px 10px;
}
.medal-item-type p {
  margin: -70px 0 0 0;
  font-size: 20px;
  font-weight: bold;
  opacity: 0.8;
}
.month {
  position: absolute;
  top: 35px;
  left: 30px;
  padding-left: 5px;
  width: 25px;
}
.day {
  position: absolute;
  top: 55px;
  right: 35px;
  padding-left: 2px;
  width: 25px;
}
.show-active-home {
  position: absolute;
  z-index: 11;
  width: 300px;
  height: 70px;
  left: 60px;
  top: 30px;
}
.show-active-tea {
  position: absolute;
  z-index: 11;
  width: 300px;
  height: 70px;
  left: 390px;
  top: 30px;
}
.up-arrow {
  width: 65px;
  position: absolute;
  top: 290px;
  right: 50px;
  z-index: 10;
}
.down-arrow {
  width: 65px;
  position: absolute;
  top: 410px;
  right: 50px;
  z-index: 10;
}
.gold-medal-count {
  top: 175px;
}
.silver-medal-count {
  top: 350px;
}
.copper-medal-count {
  top: 525px;
}
.position-Adjustment {
  position: absolute;
  left: 55px;
  width: 150px;
  text-align: center;
  font-size: 40px;
  font-weight: bold;
}

</style>




// WEBPACK FOOTER //
// src/pages/History.vue